import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  getYardRowsSlotsAction,
  getAllYardsListingAction,
  getAllRowsByYardIdAction,
  getAllSlotsByRowIdAction,
  getAllAvailableSlotsByRowIdAction,
  updateYardSlotAction,
  getYardTrail,
  removeVehicleFromYard,
  getActiveAllYardsListingAction,
  getActiveAllContainerYardsListingAction,
  getAllAvailableContainerSlotsByRowIdAction,
  getContainerYardRowsSlotsAction,
  getContainerYardTrail,
} from "./actions/yardActions";

// Define a type for the slice state
interface yardState {
  loader: true | false;
  allYards: [];
  allYardRows: [];
  yardRowsSlots: [];
  yardStats: any;
  allSlotsByRowId: [];
  allAvailableSlotsByRowId: [];
  yardTrail: [];
  selectedVehicleId: number;
  selectedGatePassId: number;
  indexId?: number;
  componentYardId: number;
  selectedYardId: number;
  selectedYardRowId: number;
  selectedYardRowSlotId: number;
  drawerOpenedFor: string;
}
const initialState: yardState = {
  loader: false,
  allYards: [],
  allYardRows: [],
  yardRowsSlots: [],
  yardStats: null,
  allSlotsByRowId: [],
  allAvailableSlotsByRowId: [],
  yardTrail: [],
  selectedVehicleId: 0,
  selectedGatePassId: 0,
  indexId: 0,
  componentYardId: 0,
  selectedYardId: 0,
  selectedYardRowId: 0,
  selectedYardRowSlotId: 0,
  drawerOpenedFor: "",
};

export const yardSlice = createSlice({
  name: "yard",
  initialState: initialState,
  reducers: {
    flushComponentRecord: (state) => {
      state.allYards = [];
    },
    addVehicleId: (state, { payload }) => {
      state.selectedVehicleId = payload;
    },
    addComponentYardId: (state, { payload }) => {
      state.componentYardId = payload;
    },
    addYardId: (state, { payload }) => {
      state.selectedYardId = payload;
      state.allAvailableSlotsByRowId = [];
    },
    addSlotId: (state, { payload }) => {
      state.selectedYardRowSlotId = payload;
    },
    resetForm: (state) => {
      state.allYardRows = [];
      state.allAvailableSlotsByRowId = [];
      state.selectedYardId = 0;
      state.selectedYardRowId = 0;
      state.selectedYardRowSlotId = 0;
    },
    drawerOpenedFor: (state, { payload }) => {
      state.drawerOpenedFor = payload;
    },
    addYardRowRecord: (state, { payload }) => {
      state.selectedYardId = payload.yardId;
      state.selectedYardRowId = payload.rowId;
      state.selectedYardRowSlotId = payload.slotId;
      state.selectedGatePassId = payload.gatePassId;
      state.indexId = payload.indexId;
    },
    setYardRowSlots: (state, { payload }) => {
      state.yardRowsSlots = payload;
    },
  },
  extraReducers: (builder) => {
    // handle Asynchronous Calls
    // Get getYardRowsSlotsAction methods
    builder.addCase(getYardRowsSlotsAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getYardRowsSlotsAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getYardRowsSlotsAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.yardRowsSlots = payload.yardColumDetails;
      state.yardStats = payload.yardStats;
    });
    builder.addCase(getContainerYardRowsSlotsAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getContainerYardRowsSlotsAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getContainerYardRowsSlotsAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.yardRowsSlots = payload.yardColumDetails;
      state.yardStats = payload.yardStats;
    });
    // ./Get getYardRowsSlotsAction methods
    // Get getAllYardsListingAction methods
    builder.addCase(getAllYardsListingAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllYardsListingAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllYardsListingAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allYards = payload;
    });
    // Get getActiveAllYardsListingAction methods
    builder.addCase(getActiveAllYardsListingAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getActiveAllYardsListingAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getActiveAllYardsListingAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allYards = payload;
    });

    builder.addCase(getActiveAllContainerYardsListingAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getActiveAllContainerYardsListingAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getActiveAllContainerYardsListingAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allYards = payload;
    });
    // ./Get getActiveAllYardsListingAction methods
    // Get getAllRowsByYardIdAction methods
    builder.addCase(getAllRowsByYardIdAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllRowsByYardIdAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllRowsByYardIdAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allYardRows = payload;
    });
    // ./Get getAllRowsByYardIdAction methods
    // Get getAllSlotsByRowIdAction methods
    builder.addCase(getAllSlotsByRowIdAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllSlotsByRowIdAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllSlotsByRowIdAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allSlotsByRowId = payload;
    });
    // ./Get getAllSlotsByRowIdAction methods
    // Get getAllAvailableSlotsByRowIdAction methods
    builder.addCase(getAllAvailableSlotsByRowIdAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllAvailableSlotsByRowIdAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllAvailableSlotsByRowIdAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allAvailableSlotsByRowId = payload;
    });
    builder.addCase(getAllAvailableContainerSlotsByRowIdAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getAllAvailableContainerSlotsByRowIdAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getAllAvailableContainerSlotsByRowIdAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.allAvailableSlotsByRowId = payload;
    });
    // ./Get getAllAvailableSlotsByRowIdAction methods
    // PUT updateYardSlotAction methods
    builder.addCase(updateYardSlotAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateYardSlotAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateYardSlotAction.fulfilled, (state) => {
      state.loader = false;
    });
    // ./PUT updateYardSlotAction methods
    // ./Get getAllSlotsByRowIdAction methods
    // Get getYardTrail methods
    builder.addCase(getYardTrail.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getYardTrail.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getYardTrail.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.yardTrail = payload;
    });
    builder.addCase(getContainerYardTrail.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getContainerYardTrail.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getContainerYardTrail.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.yardTrail = payload;
    });
    // ./Get getYardTrail methods
    // Get removeVehicleFromYard methods
    builder.addCase(removeVehicleFromYard.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(removeVehicleFromYard.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(removeVehicleFromYard.fulfilled, (state) => {
      state.loader = false;
    });
    // ./Get removeVehicleFromYard methods
  },
});

export const {
  addYardRowRecord,
  addYardId,
  addComponentYardId,
  addVehicleId,
  flushComponentRecord,
  addSlotId,
  drawerOpenedFor,
  setYardRowSlots,
  resetForm,
} = yardSlice.actions; // to Acces Reducers methods

export const loader = (state: RootState) => state.yard.loader;
export const selectAllYardsListing = (state: RootState) => state.yard.allYards;
export const selectAllYardRowsListing = (state: RootState) => state.yard.allYardRows;

export const selectYardRowsSlots = (state: RootState) => state.yard.yardRowsSlots;
export const selectYardStats = (state: RootState) => state.yard.yardStats;
export const selectAllSlotsByRowId = (state: RootState) => state.yard.allSlotsByRowId;
export const selectOnlyAvailableAllSlotsByRowId = (state: RootState) =>
  state.yard.allAvailableSlotsByRowId;
export const selectYardTrail = (state: RootState) => state.yard.yardTrail;

export const selectedVehicleId = (state: RootState) => state.yard.selectedVehicleId;
export const selectedGatePassId = (state: RootState) => state.yard.selectedGatePassId;
export const seletedIndexId = (state: RootState) => state.yard.indexId;
export const selectComponentYardId = (state: RootState) => state.yard.componentYardId;
export const selectedYardId = (state: RootState) => state.yard.selectedYardId;
export const selectedYardRowId = (state: RootState) => state.yard.selectedYardRowId;
export const selectedYardRowSlotId = (state: RootState) => state.yard.selectedYardRowSlotId;
